export class  DropRequest {
    amount: number;
    player_count: number;
}
